import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 17 16"
    fill="none"
    stroke="#007AFF"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7 .5h3v3H7zm6 6h3v3h-3zm-6 0h3v3H7zm0 6h3v3H7zm6-12h3v3h-3zm-12 12h3v3H1zm0-6h3v3H1z" />
  </svg>
);
const Memo = memo(SvgCalendar);
export default Memo;
